
  var _styles = {
  "linear-gradient-text-wrap": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "position": "relative"
  },
  "linear-gradient-text-hidden-text": {
    "fontFamily": "meituantype-Bold",
    "fontWeight": "700",
    "fontSize": "0.42667rem",
    "lineHeight": "0.45333rem",
    "opacity": 0
  },
  "linear-gradient-text-svg-cntr": {
    "position": "absolute",
    "top": 0,
    "left": 0,
    "right": 0,
    "bottom": 0,
    "display": "flex"
  },
  "gradient-text": {
    "fontFamily": "meituantype-Bold",
    "backgroundImage": "linear-gradient(106deg, #4F88FF 17%, #8E60FF 67%, #AC50FF 100%)",
    "WebkitBackgroundClip": "text",
    "backgroundClip": "text",
    "color": "rgba(0,0,0,0)",
    "fontSize": "0.42667rem",
    "lineHeight": "0.69333rem"
  }
};



  module.exports = _styles;
  